interface IDownloadFileFromUrlOptions {
  url: string;
  fileName?: string;
}

/**
 * Downloads a file from the specified URL and prompts the user to save it
 * with the given file name.
 *
 * @param {string} options.url - The URL of the file to download.
 * @param {string} [options.fileName='file'] - The name to save the downloaded file as.
 *
 * @returns {Promise<void>} A promise that resolves when the download is initiated.
 *
 * @example
 * // To download a file from a URL
 * downloadFileFromUrl({
 *   url: 'https://example.com/path/to/file.pdf',
 *   fileName: 'my-file.pdf',
 * });
 */
export async function downloadFileFromUrl({
  url,
  fileName = 'file',
}: IDownloadFileFromUrlOptions): Promise<void> {
  const res = await fetch(url);
  const blob = await res.blob();

  const blobUrl = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = fileName;
  a.click();

  URL.revokeObjectURL(blobUrl);
}
